<template>
  <modal
    class="addDriver"
    name="updateCompanyBankRequest"
    transition="pop-out"
    :width="modalWidth"
    :height="450"
    @opened="opened"
  >
    <div class="retainership__box">
      <div class="text-center">
        <h3 class="add__retainership__header mt-2">
          <span>
            <img src="@/assets/img/Group 484.png" width="50px" />
          </span>
          {{ $t("text.products.updateBankRequest") }}
        </h3>

        <div class="sign_up_form_section">
          <!-- <form class="d-flex justify-content-between">
						<div class="d-flex align-items-center">
							<div class="mr-2">
								<input
									type="radio"
									:checked="!isBranch"
									@change="() => (account = 'company')"
								/>
							</div>
							<label>
								Company Account
							</label>
						</div>

						<div class="d-flex align-items-center">
							<div class="mr-2">
								<input
									type="radio"
									:checked="isBranch"
									@change="() => (account = 'branch')"
								/>
							</div>
							<label>
								Branch Account
							</label>
						</div>
					</form> -->

          <form>
            <div class="row">
              <div class="col-md-6">
                <div style="display: flex; justify-content: flex-start">
                  <label class="required">
                    {{ $t("text.cBank.accountName") }}
                  </label>
                </div>
                <div class="input__block" ref="target_input_div">
                  <input
                    style="padding: 20px; width: 100%"
                    type="text"
                    :placeholder="$t('text.cBank.accountName')"
                    v-model="newDetails.accountName"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div style="display: flex; justify-content: flex-start">
                  <label class="required">
                    {{ $t("text.cBank.accountNumber") }}
                  </label>
                </div>
                <div class="input__block" ref="target_input_div">
                  <input
                    style="padding: 20px; width: 100%"
                    type="number"
                    :placeholder="$t('text.cBank.accountNumber')"
                    v-model="newDetails.accountNumber"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div style="display: flex; justify-content: flex-start">
                    <label class="required">
                      {{ $t("text.drivers.accountType") }}
                    </label>
                  </div>
                  <div class="input__block" ref="target_input_div">
                    <select v-model="newDetails.accountType">
                      <option value="selectAcctType">
                        {{ $t("text.bSettlement.selectAccType") }}
                      </option>
                      <option value="POS">
                        {{ $t("text.endOfDayReport.pos") }}
                      </option>
                      <option value="efueling">
                        {{ $t("text.products.efueling") }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div style="display: flex; justify-content: flex-start">
                    <label class="required">
                      {{ $t("text.linkBankAccModal.bank") }}
                    </label>
                  </div>
                  <div ref="target_input_div">
                    <multiselect
                      v-model="selectedBank"
                      track-by="bankCode"
                      label="bankName"
                      :show-labels="false"
                      :placeholder="$t('text.shiftDeposits.selectBank')"
                      :options="bankNames"
                      :searchable="true"
                      :allow-empty="false"
                      :loading="bankLoading"
                    >
                      <template slot="singleLabel" slot-scope="{ option }"
                        >{{ option.bankName }}
                      </template>
                    </multiselect>
                  </div>
                </div>
              </div>

              <!-- SELECT BRANCH -->

              <!-- <div class="form_input_section mt-4" v-if="isBranch">
								<div style="display: flex; justify-content: flex-start">
									<label class="required">
										{{ $t("text.mapPartnerToBranch.selectBranch") }}
									</label>
								</div>
								<div ref="target_input_div">
									<multiselect
										v-model="isBranch"
										track-by="name"
										label="name"
										:show-labels="false"
										:placeholder="$t('text.cBranchLease.selectBranch')"
										:options="branches"
										:searchable="true"
										:allow-empty="false"
									>
										<template slot="singleLabel" slot-scope="{ option }"
											>{{ option.name }}
										</template>
									</multiselect>
								</div>
							</div> -->
            </div>

            <div class="text-center mt-5">
              <button
                class="add_quick_fuel_btn"
                @click="updateBankAccountRequest($event)"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                <span> {{ $t("text.actionButtons.update") }} </span>
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="35px"
                  class="ml-3 loader"
                />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";

import Multiselect from "vue-multiselect";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "makeRequest",
  props: ["companyId", "branches", "details"],
  components: {
    Multiselect,
  },
  data() {
    return {
      selectedBank: "",
      selectedBranch: null,
      bank: null,
      bankNames: [],
      accountNumber: null,
      accountType: "selectAcctType",
      // accountName: null,
      account: "",
      isBranch: "",
      modalWidth: MODAL_WIDTH,
      formIsValid: false,
      isButtonDisabled: false,
      bankLoading: false,
    };
  },
  computed: {
    newDetails() {
      if (this.details) {
        this.selectedBank = this.bankNames.find((bank) => {
          return bank.bankCode === this.details.bankCode;
        });
        if (this.details.branchId) {
          this.account = "branch";
          this.isBranch = this.branches.find(
            (branch) => branch.id === this.details.branchId
          );
        }
      }
      return this.details;
    },
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },

  methods: {
    opened() {
      this.getBanks();
    },
    getBanks() {
      this.bankLoading = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Banks?companyId=${
            this.companyId ? this.companyId.id : " "
          }&branchId=${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.bankLoading = false;
          response.data.unshift({
            bankName: this.$t("text.editAccountDetailsModal.selectBank"),
            bankCode: null,
          });
          this.bankNames = response.data;
        })
        .catch((error) => {});
    },

    updateBankAccountRequest($event) {
      $event.preventDefault();
      this.isButtonDisabled = true;
      if (!this.newDetails.accountName) {
        this.$toast.open({
          message: this.$t("text.errors.accountNameMissing"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.newDetails.accountNumber) {
        this.$toast.open({
          message: this.$t("text.errors.accountNumberMissing"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.selectedBank) {
        this.$toast.open({
          message: this.$t("text.errors.bankMissing"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }

      if (
        this.newDetails.accountType === "selectAcctType" ||
        !this.newDetails.accountType
      ) {
        this.$toast.open({
          message: this.$t("text.errors.enterAcctType"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }

      // if (this.account === "branch" && !this.isBranch) {
      // 	this.$toast.open({
      // 		message: this.$t("text.errors.selectBranch"),
      // 		type: "error",
      // 		duration: 5000,
      // 	});
      // 	this.formIsValid = false;
      // 	return;
      // }

      let data = {
        accountName: this.newDetails.accountName,
        accountNumber: this.newDetails.accountNumber,
        bankCode: this.selectedBank ? this.selectedBank.bankCode : null,
        accountType: this.newDetails.accountType,
        // branchId:
        // 	this.isBranch && this.account === "branch" ? this.isBranch.id : null,
        // companyId: this.companyId.id,
      };

      $(".loader").show();

      this.axios
        .put(
          `${configObject.apiBaseUrl}/BankAccountRequest/UpdateRequest/${this.newDetails.id}`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;

          this.closeModal();
          this.$eventHub.$emit("getBankRequest");
          this.$toast.open({
            message: this.$t("text.products.requestSent"),
            type: "success",
            duration: 5000,
          });
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },

    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    closeModal() {
      this.$modal.hide("updateCompanyBankRequest");
    },
  },
};
</script>
